import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import DatePicker from 'react-datepicker';
import NewTreatmentForm from './newTreatment';
import EditTreatmentForm from './editTreatment';
import { fetchTreatments, deleteTreatment } from './../../../actions/addTreatments';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import ViewTreatment from './viewTreatment';
import { Loader } from '../../../components/loader';
import { NotificationManager } from 'react-notifications';
import classnames from 'classnames';
import { NavLink } from "react-router-dom";
import { Activity } from '../../../components/activity';


import { BreadCrumb } from '../../../components/breadcrumb';
const $ = window.$;
const ctOptions = {
    0: 'Formula',
    1: 'Dosage',
    2: 'Tablet'
}

const statusOptions = {
    0: 'Pending',
    1: 'In progress',
    2: 'Completed'
}

var tableHeaderColumnData = [];
const { SearchBar } = Search;

class TreatmentList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            contentData: [],
            cdInprogress: [],
            cdPending: [],
            cdCompleted: [],
            treatId: '',
            editTreatmentId: '',
            selectedTab: 'All',
            countDuplicateId:0,
           
        };
    }

    tableHeaderColumnData = [
        {
            dataField: 'actions', text: 'Actions', formatter: this.buttonFormatter.bind(this)
        },
        {
            dataField: 'pet_id', text: 'Pet ID', sort: true, formatter: (cell, row) => {
                return (
                  <span className="m-topbar__userpic">
                    <img src={process.env.REACT_APP_S3_PATH + '/' + row.avatar_path + '/' + row.avatar_file_name} className="m--img-rounded m-width-50 mr-2" alt="" />
                    <span className="m-badge m-badge--info mx-auto my-0 px-2"><strong>{cell}</strong></span>
                  </span>
                )
            }
        },
        {
            dataField: 'breed', text: 'Breed', sort: true
        },
        {
            dataField: 'gender', text: 'Gender', sort: true
        },
        {
            dataField: 'calculation_name', text: 'Medication', sort: true
        },
        {
            dataField: 'dosage', text: 'Dosage', sort: true
        },
        {
            dataField: 'daysLeft', text: 'Days left', sort: true
        },

        {
            dataField: 'status', text: 'Status', sort: true, formatter: (cell, row) => {
                return (
                    <span className={"m-badge mx-auto my-0 px-2 " + ((cell === 'Pending') ? 'm-badge--info' : (cell === 'In Progress') ? 'm-badge--primary' : (cell === 'Completed') ?  'm-badge--success' : ' m-badge--wide')}><strong>{cell}</strong></span>
                )
              },
              filterValue: (cell, row) => {
                for(let t in statusOptions){              
                  if(statusOptions[t]===cell){                      
                    return t;
                  }
                }
              }
        },
        {
            dataField: 'createdBy', text: '', formatter: (cell, row) => {
              return ( 
                <Activity  row={row} created={row.createdTreatment} updated={row.updatedTreatment} deleted={row.deletedTreatment}/>
              );
            },
            headerStyle: (selector, id) => {
              return { width: "50px", textAlign: "center" };
            }
          }
    ];
    
    buttonFormatter(cell, row) {
        return (
            <div>
                <a onClick={() => this.openViewModal(row.id)} className="m-portlet__nav-link btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill" title="View">
                    <i className="far fa-eye"></i>
                </a>
                <span className="dropdown show">
                    <span className="dropdown">
                    <a href="" className="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill" data-toggle="dropdown" aria-expanded="true">
                        <i className="la la-ellipsis-h"></i>
                    </a>
                    <div className="dropdown-menu dropdown-menu-right">
                    <a className="dropdown-item" onClick={ () => this.openEditModal(row.id) }>
                        <i className="la la-edit"></i> Edit
                        </a>
                        <a className="dropdown-item" onClick={ () => this.openConfirmModal(row.id) }>
                        <i className="la la-trash-o"></i> Delete
                        </a>

                    </div>
                    </span>
                </span>
            </div>
        );
    }
    
    openViewModal(tId) {
        this.setState({treatId: tId})
        $('#view_treatment').modal('show');
    }

    openConfirmModal(tId) {
        this.setState({deleteTId: tId})
        $('#confirm_delete_modal').modal('show');
    }

    openEditModal(tId) {    
     
        if(this.state.editTreatmentId == tId){           
            let count = this.state.countDuplicateId +1;     
            this.setState({ editTreatmentId : tId, countDuplicateId : count }, () =>{
                $('#edit_treatment').modal('show');  
            }); 
        }
        else{            
            this.setState({ editTreatmentId : tId, countDuplicateId : 1 }, () =>{
                $('#edit_treatment').modal('show');  
            });
        }    
       
    }

    deleteTreatment(){
        this.setState({ loading: true });
        
        if(this.state.deleteTId)
            this.props.deleteTreatment(this.state.deleteTId);
        else {
            NotificationManager.warning('Invalid treatment.');
            this.setState({ loading: false });
        }
    }

    updateFromChild(){ 
       
      this.props.fetchTreatments();  
    }

    componentDidMount() {
        const option =  this.props.match.params.option ?  this.props.match.params.option : "All"
        this.setState({ selectedTab : option })
        this.props.fetchTreatments();
    }

    componentWillReceiveProps = (nextProps) => {
        if (nextProps.data.addFormulaReducer.setTreatments !== this.props.data.addFormulaReducer.setTreatments) {
            this.props.fetchTreatments();
        }
        if (nextProps.data.addFormulaReducer.treatment !== this.props.data.addFormulaReducer.treatment) {
            let cdPending = nextProps.data.addFormulaReducer.treatment.filter(m => m.status==='Pending');
            let cdInprogress = nextProps.data.addFormulaReducer.treatment.filter(m => m.status==='In Progress');
            let cdCompleted = nextProps.data.addFormulaReducer.treatment.filter(m => m.status==='Completed');
            

            this.setState({ contentData: nextProps.data.addFormulaReducer.treatment, cdPending: cdPending, cdInprogress: cdInprogress, cdCompleted: cdCompleted, loading : false });
        }

        if (nextProps.data.addFormulaReducer.treatmentsToDelete !== this.props.data.addFormulaReducer.treatmentsToDelete) {
            this.setState({loading: false});
            this.props.fetchTreatments();
            NotificationManager.success("Treatment Deleted Successfully");
            $('#confirm_delete_modal').modal('hide');
        }
    } 

    items = [
        {title: 'Treatments', to: '/treatments'}
    ]

    render() {
        const { contentData, cdInprogress, cdPending, cdCompleted } = this.state;

        return (
            <div className="m-grid m-grid--hor m-grid--root m-page">
                <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
                    <BreadCrumb items={this.items}/>
                    <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
                        <div className="m-grid__item m-grid__item--fluid m-wrapper">
                            <div className="m-portlet m-portlet--mobile">
                                <div className="m-portlet__head">
                                    <div className="m-portlet__head-caption">
                                        <div className="m-portlet__head-title">
                                            <h3 className="m-portlet__head-text">Medicating List                                         
                                            </h3>
                                        </div>
                                    </div>
                                    <div className="m-portlet__head-tools">
                                        <ul className="m-portlet__nav">
                                            <li className="m-portlet__nav-item">
                                                <a href="#" className="btn btn-accent m-btn m-btn--custom m-btn--pill m-btn--icon m-btn--air" data-toggle="modal" data-target="#new_treatment">
                                                <span><i className="la la-plus"></i><span className="hide_in_mobile">New Medicating</span></span>
                                                </a>
                                            </li>
                                            <li className="m-portlet__nav-item">
                                                <NavLink
                                                to={`/calculators`}
                                                className="btn btn-accent m-btn m-btn--custom m-btn--pill m-btn--icon m-btn--air"
                                                >                                             
                                                   <span><i className="flaticon-squares-3"></i><span className="m-menu__link-text hide_in_mobile">Medicating Settings</span></span>
                                                </NavLink>
                                            </li>    
                                        </ul>
                                    </div>
                                </div>
                                <div className="m-portlet__body">
                                    <ul className="nav nav-pills nav-pills--success m-nav-pills--btn-pill m-nav-pills--btn" role="tablist">
                                        <li className="nav-item m-tabs__item">
                                            <button className={classnames({"nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none":true, "active":this.state.selectedTab === 'All'})} onClick={() => this.setState({ selectedTab: 'All' })}>All</button>
                                        </li>
                                        <li className="nav-item m-tabs__item">
                                            <button className={classnames({"nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none":true, "active":this.state.selectedTab === 'InProgress'})} onClick={() => this.setState({ selectedTab: 'InProgress' })}>In Progress</button>
                                        </li>
                                        <li className="nav-item m-tabs__item">
                                            <button className={classnames({"nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none":true, "active":this.state.selectedTab === 'Pending'})} onClick={() => this.setState({ selectedTab: 'Pending' })}>Pending</button>
                                        </li>
                                        <li className="nav-item m-tabs__item">
                                            <button className={classnames({"nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none":true, "active":this.state.selectedTab === 'Completed'})} onClick={() => this.setState({ selectedTab: 'Completed' })}>Completed</button>
                                        </li>
                                    </ul>
                                    <div className="tab-content">
                                        <div className="tab-pane active" id="m_tabs_6_1" role="tabpanel">
                                         { !this.state.loading ?
                                            <ToolkitProvider

                                                keyField="id"
                                                data={this.state.selectedTab === 'All' ? contentData : this.state.selectedTab === 'InProgress' ? cdInprogress : this.state.selectedTab === 'Pending' ? cdPending : this.state.selectedTab === 'Completed' ? cdCompleted : {}} 
                                                columns={this.tableHeaderColumnData}
                                                search
                                                defaultSortDirection="asc"
                                                hover={true}
                                                
                                                filter={filterFactory()}
                                            >
                                                {
                                                    props => (
                                                        <div>
                                                            <div className='px-0 mb-4 search-bar'>
                                                                <div className='col-lg-3 px-0 inner-addon right-addon'>
                                                                <i className="fas fa-search"></i>
                                                                <SearchBar {...props.searchProps} />
                                                                </div>
                                                                </div>
                                                            <BootstrapTable
                                                                classes="petTable"
                                                                {...props.baseProps}
                                                                pagination={paginationFactory()}
                                                            />
                                                        </div>
                                                    )
                                                }
                                            </ToolkitProvider>:
                                               <div className="center-row">
                                               <Loader size={50} />  
                                             </div>
                                           }
                                            {/* <BootstrapTable classes="petTable" keyField="id" columns={this.tableHeaderColumnData} data={this.state.selectedTab === 'All' ? contentData : this.state.selectedTab === 'In progress' ? cdInprogress : this.state.selectedTab === 'Pending' ? cdPending : this.state.selectedTab === 'Completed' ? cdCompleted : {}} defaultSortDirection="asc" hover={true} pagination={ paginationFactory() } filter={ filterFactory() } /> */}
                                        </div>
                                        {/* <div className="tab-pane" id="m_tabs_6_2" role="tabpanel">
                                            <BootstrapTable classes="petTable" keyField="id" columns={this.tableHeaderColumnData} data={cdInprogress} defaultSortDirection="asc" hover={true} pagination={ paginationFactory() } filter={ filterFactory() } />
                                        </div>
                                        <div className="tab-pane" id="m_tabs_6_3" role="tabpanel">
                                            <BootstrapTable classes="petTable" keyField="id" columns={this.tableHeaderColumnData} data={cdPending} defaultSortDirection="asc" hover={true} pagination={ paginationFactory() } filter={ filterFactory() } />
                                        </div>
                                        <div className="tab-pane" id="m_tabs_6_4" role="tabpanel">
                                            <BootstrapTable classes="petTable" keyField="id" columns={this.tableHeaderColumnData} data={cdCompleted} defaultSortDirection="asc" hover={true} pagination={ paginationFactory() } filter={ filterFactory() } />
                                        </div> */}
                                    </div>
                                    <ViewTreatment treatmentId={this.state.treatId} />
                                    <NewTreatmentForm />
                                    <EditTreatmentForm treatmentId={this.state.editTreatmentId} countDuplicate={this.state.countDuplicateId} updateFromChild={this.updateFromChild.bind(this)} />
                                    
                                </div>
                            </div>
                            <div className="modal fade" id="confirm_delete_modal" tabIndex="-1" role="dialog" aria-labelledby="ConfirmationModalLabel" aria-hidden="true">
                                <div className="modal-dialog" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="exampleModalLabel">Confirm to delete</h5>
                                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            <p>Are you sure you want to delete this treatment?</p>
                                        </div>
                                        <div className="modal-footer">
                                        {this.state.loading == false ?
                                            <div>
                                                <button type="button" className="btn btn-secondary m-btn--pill mx-2" data-dismiss="modal">Cancel</button>
                                                <button type="button" onClick={() => this.deleteTreatment()} className="btn btn-primary m-btn--pill">Confirm</button>
                                            </div>
                                            :
                                            <div className="center-row">
                                                <Loader size={50} />
                                            </div>
                                        }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
  user: state.cognito.user,
  data: state
});

const mapDispatchToProps = dispatch => ({
  
    fetchTreatments: () => {
        dispatch(fetchTreatments());
    },
    deleteTreatment: (selected) => {
        dispatch(deleteTreatment(selected));
    },
    
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TreatmentList));
